import {
  CURRENT_USER_REQUEST,
  CURRENT_USER_SUCCESS,
  CURRENT_USER_FAILURE,
  CURRENT_USER_LOG_OUT,
  CHANGE_LOCATION,
  USER_UPLOAD_FILES_REQUEST,
  USER_UPLOAD_FILES_SUCCESS,
  USER_UPLOAD_FILES_FAILURE,
  USER_GET_FILE_REQUEST,
  USER_GET_FILE_SUCCESS,
  USER_GET_FILE_FAILURE,
  CSS_UPDATE_REQUEST,
  CSS_UPDATE_SUCCESS,
  CSS_UPDATE_FAILURE,
  TENANT_ASSET_REQUEST,
  TENANT_ASSET_SUCCESS,
  TENANT_ASSET_FAILURE,
  TENANT_ID_CHANGE,
} from './CurrentUserActions';

const initialState = {
  data: null,
  isLoading: false,
  isFileDownloading: false,
  isFilesUploading: false,
  error: false,
  msg: null,
  queryParams: {
    tenantId: null,
    practiceId: null,
  },
};

export default function userReducer(
  state = initialState,
  { type, payload, msg, id },
) {
  switch (type) {
    case CURRENT_USER_REQUEST:
      return { ...state, isLoading: true };
    case CURRENT_USER_SUCCESS:
      return {
        ...state,
        data: payload.data,
        queryParams: {
          ...state.queryParams,
          tenantId: ((localStorage.getItem('tenant') === null) ?
            (payload.data.organizationID ? payload.data.organizationID : '0ddb51b2-38b8-4153-9c90-ded384f83a88')
            : localStorage.getItem('tenant')),
        },
        isLoading: false,
      };
    case CURRENT_USER_FAILURE:
      return { ...state, error: { ...payload }, isLoading: false };
    case CURRENT_USER_LOG_OUT:
      return { ...initialState, msg };
    case CHANGE_LOCATION:
      return {
        ...state,
        queryParams: { ...state.queryParams, practiceId: id },
      };

    case USER_UPLOAD_FILES_REQUEST:
      return { ...state, uploads: {}, isFilesUploading: true };
    case USER_UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        uploads: payload.data,
        errors: null,
        isFilesUploading: false,
      };
    case USER_UPLOAD_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFilesUploading: false,
      };

    case USER_GET_FILE_REQUEST:
      return { ...state, isFileDownloading: true };
    case USER_GET_FILE_SUCCESS:
      return { ...state, isFileDownloading: false };
    case USER_GET_FILE_FAILURE:
      return { ...state, isFileDownloading: false };

    case CSS_UPDATE_REQUEST:
      return { ...state, isLoading: true };
    case CSS_UPDATE_SUCCESS:
      return { ...state, isLoading: false };
    case CSS_UPDATE_FAILURE:
      return { ...state, isLoading: false };

    case TENANT_ASSET_REQUEST:
      return { ...state, isFileDownloading: true };
    case TENANT_ASSET_SUCCESS:
      return { ...state, isFileDownloading: false };
    case TENANT_ASSET_FAILURE:
      return { ...state, isFileDownloading: false };

    case TENANT_ID_CHANGE:
      return {
        ...state,
        queryParams: {
          ...state.queryParams,
          tenantId: id,
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/current-user/CurrentUserReducer.js